import { render, staticRenderFns } from "./dcbg.vue?vue&type=template&id=60df9031"
import script from "./dcbg.vue?vue&type=script&lang=js"
export * from "./dcbg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports